import { cx } from "class-variance-authority";
import { useTranslation } from "react-i18next";
import { Logo } from "~/components/Logo";
import asQrcode from "~/images/as_qrcode.png";
import { typography } from "~/styles/typographies";
import styles from "./Intro.module.css";

export function Intro() {
  const { t } = useTranslation("guidance");

  return (
    <div className={styles.intro}>
      <Logo className={styles.logo} />
      <div className={styles.qrCodeContainer}>
        <div>
          <a
            href="https://shortcha.sng.link/A0kry/5880/mm3d"
            rel="noreferrer"
            target="_blank"
          >
            <img alt="qrcode" src={asQrcode} />
          </a>
        </div>
        <div className={styles.textContainer}>
          <p
            className={typography({
              fontSize: "body2",
              fontWeight: "bold",
            })}
          >
            {t("qrCodeDescription")}
          </p>
          <p
            className={cx(
              typography({
                fontSize: "body3",
                fontWeight: "medium",
              }),
              styles.hookDescription,
            )}
          >
            {t("untillTheEnd")}
          </p>
        </div>
      </div>
    </div>
  );
}
